// extracted by mini-css-extract-plugin
export default {"container":"GoToBooking_container__iHGGx","backgroundImage":"GoToBooking_backgroundImage__zR7sc"};